import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { TableSearch } from "ui/components/Table/TableSearch";
import { FIRE_EXTINGUISHER_SEARCH_COLUMNS } from "./consts";
import { FireExtinguisherSearchResultsProps } from "./types";

const FireExtinguisherSearchResults: React.FC<
  FireExtinguisherSearchResultsProps
> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onPaginationChange,
    onSelectedChange,
    onVehicleClick,
  } = props;

  return (
    <TableSearch
      columns={FIRE_EXTINGUISHER_SEARCH_COLUMNS(onVehicleClick)}
      data={searchResults.data}
      selectedRows={selectedRows}
      pagination={
        searchResults.pagination || initialDataWithPagination.pagination
      }
      selectableRows={false}
      onPaginationChange={onPaginationChange}
      onSelectedChange={onSelectedChange}
      isLoading={isLoading}
    />
  );
};

export default memo(FireExtinguisherSearchResults);
